import InternalAdminsTable from
  'containers/InternalAdminsTab/components/InternalAdminsTable/themes/InternalAdminsTableLight.css';
import InternalAdminsTableFooter from
  'containers/InternalAdminsTab/components/InternalAdminsTableFooter/themes/InternalAdminsTableFooterLight.css';

export default {
  InternalAdminsTable,
  InternalAdminsTableFooter
};
